import { render, staticRenderFns } from "./workflowDialog.vue?vue&type=template&id=12e35761&scoped=true"
import script from "./workflowDialog.vue?vue&type=script&lang=js"
export * from "./workflowDialog.vue?vue&type=script&lang=js"
import style0 from "./workflowDialog.vue?vue&type=style&index=0&id=12e35761&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e35761",
  null
  
)

export default component.exports